module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Oberwil-Lieli_AG-82346696131848cd23e46b1a2526a9f8.svg";